import OrderRefundSummaryQueries from './OrderRefundSummaryQueries'

const orderRefundRequest = {
  orderRefundRequest: {
    ...OrderRefundSummaryQueries
  }
}

export default orderRefundRequest